export default __webpack_public_path__ + "static/media/productHelp.c6298c21.png";